import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../modules/companies/register-panels'
import { RetentionPipelinePage } from '../../../modules/retention/retention-pipeline-page'
import { PANEL_TYPES } from '../../../shell/panel-state'

const retentionSearchSchema = z.object({
  q: z.string().optional(),
  view: z.enum(['table', 'board']).optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
})

/** `/retention` - churn-risk accounts; renewals + cancellations are subnavs. */
export const Route = createFileRoute('/_authed/retention/')({
  validateSearch: retentionSearchSchema,
  component: RetentionRoute,
})

function RetentionRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <RetentionPipelinePage
      mode="all"
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => ({ ...prev, ...patch })) as never,
          replace: true,
        })
      }
    />
  )
}
